import { ResourceOptions } from 'react-admin';
import { FaBullhorn } from 'react-icons/fa';
import { Resources } from '../resource';
import './init';

export { default as list } from './List';
export { default as edit } from './Edit';
export { default as create } from './Create';

export const name = Resources.announcementPopup;
export const icon = FaBullhorn;
export const options: ResourceOptions = {
  label: 'resource.announcementPopup',
};
